import logo1998 from "../../assets/img/historicEvents/LogoFullyLoaded/1998.png";
import logo1999 from "../../assets/img/historicEvents/LogoFullyLoaded/1999.png";
import logo2000 from "../../assets/img/historicEvents/LogoFullyLoaded/2000.png";

export const fullyLoadedDetail = {
  "fully-loaded": {
    id: "fully-loaded",
    title: "Fully Loaded",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "fully-loaded",
        items: [
          {
            id: "fully-loaded-1998",
            title: "Fully Loaded",
            description: "In Your House 1998",
            imgUrl: logo1998,
          },
          {
            id: "fully-loaded-1999",
            title: "Fully Loaded",
            description: "End of a Era 1999",
            imgUrl: logo1999,
          },
          {
            id: "fully-loaded-2000",
            title: "Fully Loaded",
            description: "The Crap Shoot. 2000",
            imgUrl: logo2000,
          },
        ],
      },
    ],
  },
};
